module.exports = __webpack_public_path__ + "img/photo.2aa26988.svg";